//src/app/features/questionnaires/edit/TaxQuestionnaire/PersonalDetails/TheBasics/CovidRelief/slice.ts
import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export interface CovidReliefStateValues {
  receivedCovidPayment: Nullable<TYesOrNo>;
  receivedCovidPaymentFirstOrSecond: Nullable<string>;
  firstGovStimulusCopy: Nullable<string>;
  firstGovStimulusAmount: Nullable<string>;
  secondGovStimulusCopy: Nullable<string>;
  secondGovStimulusAmount: Nullable<string>;
  diagnosedWithCovid: Nullable<TYesOrNo>;
  adverseFinancialImpact: Nullable<TYesOrNo>;
  unableToWorkDueLackClildCare: Nullable<TYesOrNo>;
  clildCarehowManyDays: Nullable<string>;
  clildCareChildName: Nullable<string>;
  clildCareSchoolName: Nullable<string>;
  clildCareConfirmNoOtherPerosns: Nullable<string>;
  uOrSpouseTakeEarlyDistrubutions: Nullable<TYesOrNo>;
  unableToWorkDueToCovid: Nullable<TYesOrNo>;
  subjectToQuarentine: Nullable<TYesOrNo>;
  subjectToQuarentineDays: Nullable<string>;
  subjectToQuarentineGovEntity: Nullable<string>;
  advicedToQuarentine: Nullable<TYesOrNo>;
  advicedToQuarentineDays: Nullable<string>;
  advicedToQuarentineHelathProvider: Nullable<string>;
  experiencedSymptoms: Nullable<TYesOrNo>;
  experiencedSymptomsDays: Nullable<string>;
  careForAnIndividual: Nullable<string>;
  careForAnIndividualHealthCareNameProvider: Nullable<string>;
  careForAnIndividualDaysUnableToWork: Nullable<string>;
  careForAnIndividualGovEntity: Nullable<string>;
  receiveFamilyBenefits: Nullable<TYesOrNo>;
  additionalNotes: Nullable<string>;
}

export interface CovidReliefState {
  values: CovidReliefStateValues;
}

const initialState: CovidReliefState = {
  values: {
    receivedCovidPayment: null,
    receivedCovidPaymentFirstOrSecond: null,
    firstGovStimulusCopy: null,
    firstGovStimulusAmount: null,
    secondGovStimulusCopy: null,
    secondGovStimulusAmount: null,
    diagnosedWithCovid: null,
    adverseFinancialImpact: null,
    unableToWorkDueLackClildCare: null,
    clildCarehowManyDays: null,
    clildCareChildName: null,
    clildCareSchoolName: null,
    clildCareConfirmNoOtherPerosns: null,
    uOrSpouseTakeEarlyDistrubutions: null,
    unableToWorkDueToCovid: null,
    subjectToQuarentine: null,
    subjectToQuarentineDays: null,
    subjectToQuarentineGovEntity: null,
    advicedToQuarentine: null,
    advicedToQuarentineDays: null,
    advicedToQuarentineHelathProvider: null,
    experiencedSymptoms: null,
    experiencedSymptomsDays: null,
    careForAnIndividual: null,
    careForAnIndividualHealthCareNameProvider: null,
    careForAnIndividualDaysUnableToWork: null,
    careForAnIndividualGovEntity: null,
    receiveFamilyBenefits: null,
    additionalNotes: '',
  },
};

const covidReliefSlice = createSlice({
  name: 'covid_relief',
  initialState,
  reducers: {
    update(state, action: PayloadAction<CovidReliefStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof CovidReliefStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.personal_details
              .the_basics.covidRelief.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey } = covidReliefSlice.actions;
export default covidReliefSlice.reducer;

export const selectCovidRelief = (state: RootState) =>
  state.taxQuestionnaire.personal_details.the_basics.covidRelief;
